module.exports = __webpack_public_path__ + "static/media/yumaomi.77273457.png";